import { render, staticRenderFns } from "./LeadsInsight.vue?vue&type=template&id=6e67f920&scoped=true&"
import script from "./LeadsInsight.vue?vue&type=script&lang=js&"
export * from "./LeadsInsight.vue?vue&type=script&lang=js&"
import style0 from "./LeadsInsight.vue?vue&type=style&index=0&id=6e67f920&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e67f920",
  null
  
)

export default component.exports